/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Engagement_FailedInputs */

const en_us2_engagement_failed = /** @type {(inputs: Engagement_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't send. Try again.`)
};

const pt_br2_engagement_failed = /** @type {(inputs: Engagement_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar. Tente de novo.`)
};

const es_419_engagement_failed = /** @type {(inputs: Engagement_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo enviar. Inténtalo de nuevo.`)
};

const pt_pt2_engagement_failed = /** @type {(inputs: Engagement_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar. Tenta de novo.`)
};

const fr_fr2_engagement_failed = /** @type {(inputs: Engagement_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi impossible. Réessaie.`)
};

const de_de2_engagement_failed = /** @type {(inputs: Engagement_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden fehlgeschlagen. Versuch es erneut.`)
};

const it_it2_engagement_failed = /** @type {(inputs: Engagement_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio non riuscito. Riprova.`)
};

/**
* | output |
* | --- |
* | "Couldn't send. Try again." |
*
* @param {Engagement_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const engagement_failed = /** @type {((inputs?: Engagement_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Engagement_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_engagement_failed(inputs)
	if (locale === "es-419") return es_419_engagement_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_engagement_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_engagement_failed(inputs)
	if (locale === "de-DE") return de_de2_engagement_failed(inputs)
	if (locale === "it-IT") return it_it2_engagement_failed(inputs)
	return en_us2_engagement_failed(inputs)
});
export { engagement_failed as "engagement.failed" }